import { useCallback, useEffect, useRef } from "react";

type ListenerType = {
  onListenerCallback: (f: () => void) => void;
  listenerTimeoutMs: number;
};

export function useListener({
  onListenerCallback,
  listenerTimeoutMs,
}: ListenerType): () => Promise<void> {
  const listenerTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const resetListener = useCallback(() => {
    if (listenerTimeoutRef.current) {
      clearTimeout(listenerTimeoutRef.current);
    }
    listenerTimeoutRef.current = setTimeout(
      () => onListenerCallback(resetListener),
      listenerTimeoutMs,
    );
  }, [onListenerCallback, listenerTimeoutMs]);

  const startListener = useCallback(async () => {
    if (listenerTimeoutRef.current) {
      clearTimeout(listenerTimeoutRef.current);
    }
    onListenerCallback(resetListener);
  }, [onListenerCallback, resetListener]);

  useEffect(() => {
    startListener();
  }, [startListener]);

  useEffect(() => {
    return () => {
      if (listenerTimeoutRef.current) {
        clearTimeout(listenerTimeoutRef.current);
      }
    };
  }, []);

  return startListener;
}
